import { Component, OnInit } from '@angular/core';

import { saveAs } from 'file-saver';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { MaeConstanciaService } from 'src/app/service/mae-constancia.service';
import { MaeConstanciaResumenM } from 'src/app/model/mae-constancia-bean';
import { DetArchivoService } from 'src/app/service/det-archivo.service';

import { MatDialog } from "@angular/material/dialog";
import { ConfirmarComponent } from 'src/app/comunes/confirmar/confirmar.component';

@Component({
  selector: 'app-resumen',
  templateUrl: './resumen.component.html',
  styleUrls: ['./resumen.component.scss']
})
export class ResumenComponent implements OnInit {

  constructor(
    private utilitarioService:UtilitarioService,
    private maeConstanciaService:MaeConstanciaService,
    private globalVariablesService: GlobalVariablesService,
    private detArchivoService:DetArchivoService,
    private dialogo: MatDialog,
    ){
  }
  manual:string;
  manual_nombre:string;

  listConstanciasResumen:Array<MaeConstanciaResumenM>;
  listResAlum:Array<MaeConstanciaResumenM>;
  listResProf:Array<MaeConstanciaResumenM>;

  titulo_alum:String;
  titulo_prof:String;

  ngOnInit(): void {
    var perfil= this.globalVariablesService.getC_perfil();
    if(perfil==='1')
    {
      this.manual = 'a57d830a-e7b8-40dc-98e1-e1c024303603';
      this.manual_nombre = 'EConstancias_ManualUsuario-Admin.pdf';
    }
    else
    {
      this.manual = '0a0ed6e5-bcb4-4fdb-b7aa-ec65621e4ad8';
      this.manual_nombre = 'EConstancias_ManualUsuario.pdf';
    }

    this.utilitarioService.loading = true;
    this.maeConstanciaService.getresumenfirma(this.globalVariablesService.getC_usuario()).subscribe(data=>{
      this.listConstanciasResumen = data;
      this.listResAlum = this.listConstanciasResumen.filter(x=>x.c_tipo==='19');
      this.listResProf = this.listConstanciasResumen.filter(x=>x.c_tipo==='20');
      this.asignartitulo();
      this.utilitarioService.loading = false;
    });


  }

  asignartitulo()
  {
    if(this.listResAlum.length>0)
    {
      var paratit = 'una constancia lista';
      if(this.listResAlum.length>1)
        paratit = this.listResAlum.length.toString()+' constancias listas';
      this.titulo_alum = 'Tiene '+paratit+' para firmar:';
    }
    else
      this.titulo_alum = 'No tiene constancias para firmar.';


    if(this.listResProf.length>0)
    {
      var paratitp = 'una constancia lista';
      if(this.listResProf.length>1)
        paratitp = this.listResProf.length.toString()+' constancias listas';
      this.titulo_prof = 'Tiene '+paratitp+' para firmar:';
    }
    else
      this.titulo_prof = 'No tiene constancias para firmar.';
  }
  onDescargar(){
    this.utilitarioService.loading = true;
    this.detArchivoService.getFile(this.manual).subscribe(blob=>{
      this.utilitarioService.loading = false;
      saveAs(blob,this.manual_nombre);
    });

  }
}
